export default class CredentialToken {
  public token!: string;
}
